import './ShareClassConversionModal.scss'

import React from 'react';

import Content from 'services/Content';
import DisclosureModal from 'components/shared/DisclosureModal/DisclosureModal';
import { ReactComponent as QuestionCircle } from 'assets/icons/question-circle.svg';

const ShareClassConversionModal = ({
   icon,
}) => (
    <DisclosureModal
        size="jumbo"
        icon={icon || <QuestionCircle slot={'suffix'} />}
        closeOnClickOut>
        <div className="share-class-conversion-label-modal">
            <p className="label-modal-title">Important Information About Share Class Conversions</p>
            <p className="label-modal-section-header">What is a share class conversion?</p>
            <p className="label-modal-text">{Content.SCCDefinition}</p>
            <p className="label-modal-section-header">How is my Personal Rate of Return impacted by a share class conversion?</p>
            <p className="label-modal-text">{Content.SCCEffectsOnPRR}</p>
            <p className="label-modal-section-header">How will my account balance information appear after a share class conversion?</p>
            <p className="label-modal-text">{Content.SCCAccountBalanceDisplay}</p>
            <p className="label-modal-text">{Content.SCCHistoricalBalancesDisclosure}</p>
        </div>
    </DisclosureModal>
);

export default ShareClassConversionModal;
